"use client";
import { useState, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { marketplaceCdn } from "../utility/env";
import Image from "next/image";
// Import FontAwesome components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faPause, faVolumeUp, faVolumeMute } from "@fortawesome/free-solid-svg-icons";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import styles from "../styles/SellerVideos.module.css";
import Link from "next/link";
import { Autoplay, Mousewheel, Navigation, Pagination, Virtual } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const videos = [
  {
    Link: `${marketplaceCdn}/videos/seller-reviews/Video 1.webm`,
    name: " Esquire Computer and Mobile",
    logo: "https://techbazaar.pk/_next/image?url=https%3A%2F%2Fd32n7g8aqsy2ib.cloudfront.net%2Fimages%2Fprofiles%2F0TIvlnviHEtNEGrg1715930746226.46.32.jpeg&w=96&q=75",
    userName: "esquire-computer-and-mobile",
  },
  { Link: `${marketplaceCdn}/videos/seller-reviews/Video 2.webm`, name: "Pakistan Computers", logo: "https://techbazaar.pk/_next/image?url=https%3A%2F%2Fd32n7g8aqsy2ib.cloudfront.net%2Fimages%2Fprofiles%2F41NyiX5naLQJT5oX1740654738753.webp&w=64&q=75", userName: "pakistan-computers" },
  { Link: `${marketplaceCdn}/videos/seller-reviews/Video 3.webm`, name: "Hs Trader", logo: "https://techbazaar.pk/_next/image?url=https%3A%2F%2Fd32n7g8aqsy2ib.cloudfront.net%2Fimages%2Fprofiles%2FzyM6sGUMpse0VL4G1741774003745.webp&w=64&q=75", userName: "hs-traders" },
  { Link: `${marketplaceCdn}/videos/seller-reviews/Video 4.webm`, name: "Fone Arena", logo: "https://techbazaar.pk/_next/image?url=https%3A%2F%2Fd32n7g8aqsy2ib.cloudfront.net%2Fimages%2Fprofiles%2FwOppenKIw1sDMvQn1719312386921.webp&w=64&q=75", userName: "fone-arena" },
  { Link: `${marketplaceCdn}/videos/seller-reviews/Video 5.webm`, name: "DigiStar", logo: "https://techbazaar.pk/_next/image?url=https%3A%2F%2Fd32n7g8aqsy2ib.cloudfront.net%2Fimages%2Fprofiles%2FGvqoVpqBQLnmUW3w1721736086295.webp&w=64&q=75", userName: "digistar" },
];

export default function SocialMediaPost() {
  const [liked, setLiked] = useState(false);
  const [videoStates, setVideoStates] = useState([
    { playing: true, muted: true },
    { playing: true, muted: true },
    { playing: true, muted: true },
    { playing: true, muted: true },
    { playing: true, muted: true },
  ]);

  const videoRefs = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];

  // Function to toggle play/pause
  const togglePlay = (index) => {
    const newVideoStates = [...videoStates];
    const video = videoRefs[index].current;

    if (video) {
      if (newVideoStates[index].playing) {
        video.pause();
      } else {
        video.play();
      }
      newVideoStates[index].playing = !newVideoStates[index].playing;
      setVideoStates(newVideoStates);
    }
  };

  // Function to toggle mute/unmute
  // const toggleMute = (index) => {
  //   const newVideoStates = [...videoStates];
  //   const video = videoRefs[index].current;

  //   if (video) {
  //     video.muted = !video.muted;
  //     newVideoStates[index].muted = !newVideoStates[index].muted;
  //     setVideoStates(newVideoStates);
  //   }
  // };
  const toggleMute = (index) => {
    const newVideoStates = [...videoStates];

    videoRefs.forEach((ref, i) => {
      const video = ref.current;
      if (video) {
        if (i === index) {
          // Toggle the selected video

          const shouldMute = videoStates[i].muted;
          video.muted = !shouldMute;
          newVideoStates[i].muted = !shouldMute;
        } else {
          // Mute all other videos
          video.muted = true;
          newVideoStates[i].muted = true;
        }
      }
    });

    setVideoStates(newVideoStates);
  };

  return (
    <>
      {/* <div className=" main  justify-content-center mt-5 d-none d-sm-none d-md-flex d-lg-flex">

        <Row className=" justify-content-center d-flex  ">
          {videos.map((videoSrc, index) => (
            <Col xl="3" lg="3" key={index} className={`relative me-3 ${styles.videoCard}`}>
              <div className={`absolute d-flex rounded-4 align-items-center gap-2 text-light p-2 w-full pointer-events-none ${styles.verifiedSeller_div}`}>
                <FontAwesomeIcon className="rounded-5" icon={faCircleCheck} style={{ color: "white", background: "green", fontSize: "18px" }} />
                <p className="font-bold text-light fs-13 leading-tight">
                  <br />
                  Verified Seller
                </p>
              </div>
              <div className={`h-96 ${styles.video_div}`}>
                <video onClick={() => toggleMute(index)} ref={videoRefs[index]} style={{ width: "250px" }} className="w-full h-full rounded-4 object-cover" src={videoSrc.Link} autoPlay loop playsInline muted={videoStates[index].muted} />
              </div>

              <div className={`absolute top-4  w-100 justify-content-center d-flex z-10 ${styles.muteBtn}`}>
           
                <button className="bg-black bg-opacity-50 p-2 rounded-full" onClick={() => toggleMute(index)}>
                  <FontAwesomeIcon icon={videoStates[index].muted ? faVolumeMute : faVolumeUp} className="text-white" size="sm" />
                </button>
              </div>

              <Link href={`/store/${videoSrc.userName}`}>
                <div className={` ${styles.seller_div} absolute d-flex rounded-4 align-items-center gap-2 text-light p-2 w-full `}>
                  <Image src={videoSrc.logo} style={{ objectFit: "contain" }} className="rounded-5" alt="Logo" width={48} height={48} />
                  <p className="font-bold text-light fs-13 leading-tight">
                    <br />
                    {videoSrc.name}
                  </p>
                </div>
              </Link>
            </Col>
          ))}
        </Row>
      </div> */}
      <div className={`${styles.swiper_div} mx-1 mx-md-2 `}>
        <div className={` main  `}>
          <Swiper
            // cssMode={true}
            // sl={1}

            navigation={true}
            mousewheel={true}
            //   centeredSlides={true}
            modules={[Virtual, Navigation, Mousewheel]}
            //   autoplay={false}
            //   autoplay={{
            //     delay: 5500,
            //     disableOnInteraction: false,
            //   }}
            breakpoints={{
              378: {
                slidesPerView: 1,
                spaceBetween: 30,
                centeredSlides: true,
              },
              540: {
                slidesPerView: 1,
                spaceBetween: 30,
                centeredSlides: true,
              },
              640: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
              1440: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
              1600: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
              1800: {
                slidesPerView: 5,
                spaceBetween: 20,
              },
            }}
            className="mySwiper"
          >
            {videos.map((videoSrc, index) => (
              <SwiperSlide>
                <Col xl="3" lg="4" key={index} className={`relative me-3 ${styles.videoCard}`}>
                  <div className={`${styles.verifiedSeller_div} ${styles.badge}`}>
                    <FontAwesomeIcon className={styles.verifiedIcon} icon={faCircleCheck} />
                    <p className={styles.verifiedText}>Verified Seller</p>
                  </div>
                  <div className={`h-96 ${styles.video_div}`}>
                    <video onClick={() => toggleMute(index)} ref={videoRefs[index]} className={`w-full h-full rounded-4 object-cover ${styles.video}`} src={videoSrc.Link} autoPlay loop playsInline muted={videoStates[index].muted} />
                  </div>

                  {/* Video controls */}
                  <div className={styles.muteBtn}>
                    <button className={styles.muteButton} onClick={() => toggleMute(index)}>
                      <FontAwesomeIcon icon={videoStates[index].muted ? faVolumeMute : faVolumeUp} className={styles.muteIcon} />
                    </button>
                  </div>
                  {/* Text overlay */}
                  <Link href={`/store/${videoSrc.userName}`}>
                    <div className={` ${styles.seller_div} absolute d-flex rounded-4 align-items-center gap-2 text-light p-2 w-full `}>
                      <Image src={videoSrc.logo} style={{ objectFit: "contain" }} className="rounded-5" alt="Logo" width={48} height={48} />
                      <p className="font-bold text-light fs-12 leading-tight">{videoSrc.name}</p>
                    </div>
                  </Link>
                </Col>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </>
  );
}

// function SellerVideosMobile() {
//   return (

//   );
// }
